import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '../../Api/ChessRestClient';

export interface SyncStudiesPayload {
  // Lichess study ids to import. Omit to import every study on the account
  // (legacy behavior) — the study-picker flow always passes an explicit list
  // to keep Lichess API usage (and rate limiting) down.
  studyIds?: string[];
}

export default function useSyncStudies(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation<any, Error, SyncStudiesPayload | void>(
    async payload => {
      const body =
        payload && payload.studyIds ? {study_ids: payload.studyIds} : {};
      const response = await ChessRestClient.post(
        '/learning/study_games/import_further_studies/',
        body,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );
}
